import { APIProvider, Map, Marker, useMap, useMapsLibrary } from "@vis.gl/react-google-maps";
import { useEffect, useState, useMemo } from "react";

const MAPS_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
const CAMEROON_CENTER = { lat: 5.9631, lng: 10.1591 };

export default function MapComponent({ departure, destination, departureCoords, destinationCoords, height = "300px" }) {
  if (!MAPS_KEY) {
    return (
      <div className="rounded-lg bg-[#F8FAFC] border border-[#CBD5E1] flex items-center justify-center" style={{ height }} data-testid="map-placeholder">
        <p className="text-xs text-[#64748B]">Carte non disponible</p>
      </div>
    );
  }

  return (
    <div className="rounded-lg overflow-hidden border border-[#CBD5E1]" style={{ height }} data-testid="google-map">
      <APIProvider apiKey={MAPS_KEY}>
        <MapInner
          departureCoords={departureCoords}
          destinationCoords={destinationCoords}
          departure={departure}
          destination={destination}
        />
      </APIProvider>
    </div>
  );
}

function MapInner({ departureCoords, destinationCoords, departure, destination }) {
  const map = useMap();
  const routesLib = useMapsLibrary("routes");
  const [route, setRoute] = useState(null);

  const depCoords = useMemo(() => departureCoords || CAMEROON_CENTER, [departureCoords]);
  const destCoords = useMemo(() => destinationCoords || null, [destinationCoords]);

  useEffect(() => {
    if (!map || !routesLib || !depCoords || !destCoords) return;

    const directionsService = new routesLib.DirectionsService();
    const directionsRenderer = new routesLib.DirectionsRenderer({
      map,
      suppressMarkers: false,
      polylineOptions: { strokeColor: "#0A2540", strokeWeight: 4 },
    });

    directionsService.route(
      {
        origin: destCoords ? { lat: depCoords.lat, lng: depCoords.lng } : departure || "Yaounde, Cameroun",
        destination: destCoords ? { lat: destCoords.lat, lng: destCoords.lng } : destination || "Douala, Cameroun",
        travelMode: routesLib.TravelMode.DRIVING,
      },
      (result, status) => {
        if (status === "OK") {
          directionsRenderer.setDirections(result);
          setRoute(result);
        }
      }
    );

    return () => directionsRenderer.setMap(null);
  }, [map, routesLib, depCoords, destCoords, departure, destination]);

  return (
    <Map
      defaultCenter={depCoords}
      defaultZoom={destCoords ? 7 : 6}
      mapId="trigotour-map"
      style={{ width: "100%", height: "100%" }}
      gestureHandling="greedy"
      disableDefaultUI={false}
      zoomControl={true}
      mapTypeControl={false}
      streetViewControl={false}
    >
      {!route && depCoords && (
        <Marker position={depCoords} title={departure || "Depart"} />
      )}
      {!route && destCoords && (
        <Marker position={destCoords} title={destination || "Destination"} />
      )}
    </Map>
  );
}

export function SmallMap({ lat, lng, height = "200px" }) {
  const center = useMemo(() => ({ lat: lat || 3.848, lng: lng || 11.5021 }), [lat, lng]);
  const mapStyle = useMemo(() => ({ width: "100%", height: "100%" }), []);
  if (!MAPS_KEY) return null;
  return (
    <div className="rounded-lg overflow-hidden border border-[#CBD5E1]" style={{ height }}>
      <APIProvider apiKey={MAPS_KEY}>
        <Map
          defaultCenter={center}
          defaultZoom={13}
          style={mapStyle}
          gestureHandling="greedy"
          disableDefaultUI={true}
          zoomControl={true}
          mapTypeControl={false}
        >
          <Marker position={center} />
        </Map>
      </APIProvider>
    </div>
  );
}
